export const setExpiredStatus = (state, status) => {
  state.expiredStatus = status
}

export const setLimitUserStatus = (state, status) => {
  state.limitUserStatus = status
}

export const setLimitStorageStatus = (state, status) => {
  state.limitStorageStatus = status
}